var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-top",attrs:{"id":"goTop"},on:{"click":_vm.goTop}},[_c('span',{staticClass:"el-icon-arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }